var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticClass:"d-flex align-center justify-center",attrs:{"value":_vm.showLoader,"z-index":"6"}},[_c('div',{staticClass:"d-flex justify-center flex-column align-center"},[_c('v-progress-circular',{attrs:{"width":"1","indeterminate":""}}),_c('div',{staticClass:"mt-4"},[_vm._v("Please wait...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }